/**
 * Borda scoring: rank 1 (best) gets n points, rank n gets 1 point.
 * @param rank 1-indexed position (1 = top of ballot)
 * @param n number of options (≥ 2)
 */
export function bordaPointsForRank(rank: number, n: number): number {
	if (n < 2) throw new RangeError("n must be at least 2");
	if (!Number.isInteger(rank) || rank < 1 || rank > n) {
		throw new RangeError(`rank must be 1..${n}`);
	}
	return n - rank + 1;
}

/** One-line copy for the Logic Ledger pill (Curator UI). */
export function bordaPreviewSummary(n: number): string {
	if (n < 2) return "";
	const top = bordaPointsForRank(1, n);
	const bottom = bordaPointsForRank(n, n);
	return `Ranking an item #1 gives it ${top} pts; #${n} gives ${bottom} pt${bottom === 1 ? "" : "s"}.`;
}
